"use client"

import { cn } from "@/lib/utils"
import { Link } from "@inertiajs/react"
import {
  Building2, Building, Phone, FileText, Settings, Users, Globe,
  Plug, Database, CreditCard, Mail, MessageSquareText, Menu
} from "lucide-react"

import OrgSidebarDropdown from "@/components/OrgSidebarDropdown"

import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet"

const sections = [
  { id: "global_settings", label: "Global Settings", icon: Settings },
  { id: "organizations", label: "Organizations", icon: Globe },
  { id: "facilities", label: "Facilities", icon: Building2 },
  { id: "departments", label: "Departments", icon: Building },
  { id: "numbers", label: "Numbers", icon: Phone },
  //  { id: "emails", label: "Emails", icon: Mail },
  { id: "users", label: "Users", icon: Users },
  { id: "document_classification", label: "Document Classifications", icon: FileText },
  { id: "message_templates", label: "Message Templates", icon: MessageSquareText },
  /*
  {
    id: "integrations",
    label: "Integrations",
    icon: Plug,
    subsections: [
      { id: "active-integrations", label: "Active Integrations" },
      { id: "browse", label: "Browse" },
    ]
  },
  */
  { id: "our_data", label: "Our Data", icon: Database },
  { id: "billing", label: "Billing Settings", icon: CreditCard },
]

type Props = {
  activeSection: string,
  showSidebar: boolean,
  user_permissions: string[]
  setShowSidebar: (show: boolean) => void
}

export default function OrgSidebar({ activeSection, showSidebar, setShowSidebar, user_permissions }: Props) {
  console.log("Rendering OrgSidebar with sidebar:", showSidebar)
  const user_sections = sections.filter(section => {
    if (user_permissions.includes(section.id)) {
      return true
    }
    return false
  })

  return (
    <>
      {/* MOBILE HEADER WITH MENU BUTTON */}
      <div className="md:hidden sticky top-0 z-40 flex items-center justify-between bg-sidebar md:px-4 py-3 border-b border-sidebar-border">
        <Sheet open={showSidebar} onOpenChange={setShowSidebar}>
          <SheetContent side="left" className="p-0 w-64">
            <SidebarContent activeSection={activeSection} />
          </SheetContent>
        </Sheet>
      </div>

      {/* DESKTOP SIDEBAR */}
      <div className="hidden md:flex w-64 h-screen flex-col bg-sidebar text-sidebar-foreground border-r border-sidebar-border">
        <SidebarContent activeSection={activeSection} sections={user_sections} />
      </div>
    </>
  )
}

function SidebarContent({ activeSection, sections }: { activeSection: string, sections?: typeof sections }) {
  console.log("sections in SidebarContent:", sections)
  return (
    <div className="flex flex-col h-full">
      {/* TOP BRAND */}
      <div className="flex h-14 items-center border-b border-sidebar-border px-4">
        <Link href="/" className="text-lg font-semibold hover:text-foreground transition-colors">
          ← eFax
        </Link>
      </div>

      {/* NAVIGATION */}
      <div className="flex-1 overflow-y-auto py-4 space-y-1">
        {sections.map((section) => {
          const Icon = section.icon

          if (section.subsections) {
            return (
              <OrgSidebarDropdown
                key={section.id}
                label={section.label}
                icon={section.icon}
                subsections={section.subsections}
                sectionId={section.id}
                activeSection={activeSection}
              />
            )
          }

          return (
            <Link
              key={section.id}
              href={`/organization_settings/${section.id}`}
              className={cn(
                "flex items-center gap-3 px-4 py-2 text-sm transition-colors rounded-r-md",
                activeSection === section.id
                  ? "bg-sidebar-accent text-sidebar-accent-foreground font-medium"
                  : "text-sidebar-foreground/80 hover:bg-sidebar-accent/50"
              )}
            >
              <Icon className="h-4 w-4" />
              {section.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}

